import { getCheckLogin } from 'services/authService';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { useLocation } from 'react-router-dom';
import { RootState } from 'slices';
import { setAuthStatus } from 'slices/auth/login/reducer';

// const useAuth = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { authenticated } = useSelector((state: RootState) => state.Login);
//   const [authChecked, setAuthChecked] = useState(false);
//   const hasChecked = useRef(false);

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         const checkToken = await getCheckLogin();
//         dispatch(setAuthStatus(checkToken));

//         if (!checkToken) {
//           sessionStorage.setItem('redirect', location.pathname);
//         }
//       } catch (error) {
//         console.error('Error checking authentication:', error);
//         dispatch(setAuthStatus(false));
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     if (!hasChecked.current) {
//       hasChecked.current = true;
//       checkAuth();
//     }
//   }, [dispatch, location.pathname]);

//   return { authenticated, authChecked };
// };

// export { useAuth };

const useAuth = () => {
  const dispatch = useDispatch();
  const { authenticated } = useSelector((state: RootState) => state.Login);
  const [authChecked, setAuthChecked] = useState(false);
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    const checkAuth = async () => {
      try {
        const result = await getCheckLogin();
        console.log(result);
        dispatch(setAuthStatus(result));
      } catch (err) {
        console.error('auth error:', err);
        dispatch(setAuthStatus(false));
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, [dispatch]);

  return { authenticated, authChecked };
};

export { useAuth };
